import React, { useEffect, useState } from 'react';
import './styles';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import UIController from '../../../../../components/UI/UIController';
import Helmet from 'react-helmet';
import { SERVICE_REQUEST_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useLazyQuery } from '@apollo/react-hooks';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';
import { GET_ADMIN_SERVICE_REQUESTS } from './queries';

export default function AdminServiceRequests({}: AdminServiceRequestsProps) {
	const QUERY_LIMIT = 25;

	const [serviceRequests, setServiceRequests] = useState<ServiceRequestType[]>();

	const history = useHistory();
	const location = useLocation();

	const filters = useSelector(getFiltersProp);
	let props = {
		filters,
		location
	};

	let baseVariables = { query: {} };
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, SERVICE_REQUEST_TABLE_TYPE, props, baseVariables);
	const [getServiceRequests, { data: serviceRequestsData }] = useLazyQuery(GET_ADMIN_SERVICE_REQUESTS, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getServiceRequests();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (serviceRequestsData) {
				const fetchedServiceRequests: ServiceRequestType[] = serviceRequestsData['serviceRequests'];
				setServiceRequests(fetchedServiceRequests);
			}
		})();
	}, [serviceRequestsData]);

	const renderContent = () => {
		if (!serviceRequests) return <UILoadingPage />;
		return (
			<>
				<PLTable
					type={SERVICE_REQUEST_TABLE_TYPE}
					updateTable={getServiceRequests}
					limit={QUERY_LIMIT}
					emptySetText={'Nothing urgent is going on.'}
					data={serviceRequests}
					onSelect={(serviceRequest) => history.push(/service-request/ + serviceRequest.id)}
				/>
			</>
		);
	};

	return (
		<UIController bodyClassName={`adminServiceRequests`}>
			<Helmet>
				<title>Service Requests | Pineapple Labs</title>
				<meta property='og:title' content='Service Requests | Pineapple Labs' />
			</Helmet>
			{/*{renderTabComponent()}*/}
			{renderContent()}
		</UIController>
	);
}
